import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../theme/ISpcTheme';

export type VariantSliderClasses = 'root' | 'verticalOffset' | 'leftArrow' | 'rightArrow' | 'interiorViewArrow';

const variantSliderStyles = makeStyles<ISpcTheme, VariantSliderClasses>(
  theme => ({
    root: {
      zIndex: 999,

      '& .slick-slide': {
        height: 'initial',
      },
    },
    verticalOffset: {
      top: 140,

      [theme.breakpoints.down('sm')]: {
        top: 70,
      },
    },
    leftArrow: {
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
      },
    },
    rightArrow: {
      [theme.breakpoints.down('sm')]: {
        paddingRight: 0,
      },
    },
    interiorViewArrow: {
      '& svg': {
        color: theme.palette.common.white,
      },
    },
  }),
  { name: 'Common_VariantSlider' },
);

export default variantSliderStyles;
